import { BodyM, Caption } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import Image from 'next/image'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import facilities from '@/utils/listing-facilities'

import { detailFeaturesContainer, detailInfoBox, servicesContainer } from './styles.css'

type Props = {
  listing: ListingCate
}

const ServicesList: React.FC<Props> = ({ listing }) => {
  const { t } = useTranslation()
  const services = facilities.get(listing)

  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <div className={detailInfoBox}>
      {services && services.length > 0 && (
        <div
          className={cn(
            detailFeaturesContainer,
            sprinkles({
              flexDirection: 'column',
            })
          )}
        >
          <BodyM
            className={sprinkles({
              paddingBottom: 'm',
              textTransform: 'uppercase',
            })}
          >
            {t('listing-detail:services')}
          </BodyM>
          <div className={servicesContainer}>
            {services.map((service, index) => {
              return (
                <div
                  key={index}
                  className={sprinkles({
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'xs',
                    textAlign: 'center',
                  })}
                >
                  <Image height={18} src={`${imageBasePath}/images/property-details-icons/${service}.svg`} width={18} />
                  <Caption color="greyscale500">{t(`listing-detail:${service}`)}</Caption>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
export default ServicesList
